export default "__VITE_ASSET__Cu2ku_K0__"